import { getReducer } from "../utils/StoreUtils";
import { clearData } from "../utils/StorageUtils";
import { addWords, removeWords } from "../utils/StringUtils";
import { loadCMTText, loadCMTSubtitles } from "../utils/LoadUtils";
import {
	updateSubtitles,
	clearSubtitles,
} from "../redux/actions/SubtitleActions";
import { updateTexts } from "../redux/actions/TextActions";
import { updateConfig } from "../redux/actions/ConfigActions";

export function alert(message) {
	window.alert(message);
}

export function log(message) {
	console.log(message);
}

export function print() {
	window.print();
}

export function warn(message) {
	console.warn(message);
}

export function error(message) {
	console.error(message);
}

export function closeWindow() {
	self.close();
	top.window.close();
}

export function reload() {
	window.location.reload();
}

export function addClassNamesToBody(classNames) {
	document.body.className = addWords(document.body.className, classNames);
}

export function removeClassNamesFromBody(classNames) {
	document.body.className = removeWords(document.body.className, classNames);
}

export function changeLanguage(language) {
	if (!language) {
		// if language from selecct
		if (this.pageItem.type === "select") {
			const { value } = this.pageItem;
			language = value.value;
		} else {
			throw new Error(
				"Please define a language or leave blank if you're using a select drop down!"
			);
		}
	}

	updateConfig({ language });
}

export async function loadLanguage(language, updateConfigValue = false) {
	const config = getReducer("config").item;
	const newConfig = { ...config };

	if (language) {
		newConfig.language = language;
		updateConfigValue && updateConfig({ language });
	}

	// Load cmt text
	let cmtTexts;
	try {
		cmtTexts = await loadCMTText(newConfig);
	} catch (error) {
		console.warn(error);
	}

	// Load cmt subs
	let cmtSubs;
	try {
		cmtSubs = await loadCMTSubtitles(newConfig);
	} catch (error) {
		console.warn(error);
	}

	// update

	cmtTexts && updateTexts(cmtTexts);
	// clearing, because subtitles do not always share same id between languages. So if we don't clear there can
	// be duplicate subtitles for a specific file name, and PageItemSubtitles will be confused.
	clearSubtitles();

	cmtSubs && updateSubtitles(cmtSubs);

	return { cmtTexts, cmtSubs };
}

export function clearStorage() {
	clearData();
}
